import { postInternalMessage } from '../initialize';
import { createStartCallWebWorkerMessage } from './internalEventMessageCreators';
export default function startCallHandler(startCallArguments) {
  const startCallMessage = createStartCallWebWorkerMessage(startCallArguments);
  postInternalMessage(startCallMessage);
}